import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FileInputComponent } from '@common/file-input/file-input';
import { FileSelectDirective } from '@common/file-input/file-select';
import { FileDropDirective } from '@common/file-input/file-drop';
import { AppMaterialModule } from './../../app-material.module';

@NgModule({
  declarations: [FileInputComponent, FileSelectDirective, FileDropDirective],
  imports: [CommonModule, FormsModule, AppMaterialModule],
  exports: [FileInputComponent, FileSelectDirective, FileDropDirective],
})
export class FileInputModule {}
